import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import Navfirst from './Navfirst';
import { ArrowLeft, LayoutDashboard } from 'lucide-react';



const Nav = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');  // Go back to the previous route
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 h-16">
      <div className="max-w-7xl mx-auto px-4 h-full">
        <div className="flex justify-between items-center h-full">
          {/* Back Button */}
          <button
            onClick={handleBack}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 p-2 rounded-lg"
          >
            <ArrowLeft size={20} />
            <span className="font-medium">Back</span>
          </button>

          {/* Dashboard Link */}
          <a
            href="/"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200"
          >
            <LayoutDashboard size={20} />
            <span className="font-medium">Dashboard</span>
          </a>
        </div>
      </div>
    </nav>
  );
};



const Compare = () => {
  const navigate = useNavigate();
  const [product1, setProduct1] = useState('');
  const [product2, setProduct2] = useState('');
  const [userQuery, setUserQuery] = useState('');

  const handleCompare = () => {
    // Create JSON object
    const requestBody = {
      url1: product1,
      url2: product2,
      spec: userQuery,
    };

    console.log(requestBody); // Log requestBody for debugging

    // try {
    //   // Validate URL format (optional but recommended)
    //   new URL(url1);
    //   new URL(url2);

    //   navigate('/load_sum', { 
    //     state: { 
    //       requestBody: { url1 } 
    //     } 
    //   });
    // } catch (error) {
    //   alert('Please enter a valid URL format.');
    // }
    try {
      // Validate URL format for both URLs
      new URL(requestBody.url1);
      new URL(requestBody.url2);
  
      // Navigate with the full requestBody in state
      navigate('/load_com', { 
        state: { requestBody } 
      });
    } catch (error) {
      // Identify invalid input and provide specific feedback
      if (!product1 || !product2) {
        alert('Both URLs are required.');
      } else {
        alert('Please enter valid URL formats for the products.');
      }
    }

    // Navigate to results page with JSON data
    navigate('/load_com', {
      state: requestBody,
    });
  };

  return (
    <>
    <Nav/>
    <div className="min-h-[90vh] bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
      <div className="w-full max-w-[80vw] max-h-[70vh] bg-white shadow-xl rounded-xl border border-blue-100 p-6 space-y-5">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-blue-800 mb-2">Product Comparator</h2>
          <p className="text-sm text-gray-500">Enter two product URL's (from amazon.in only) to compare products</p>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Product 1</label>
            <input
              type="text"
              placeholder="Enter first product url"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
              value={product1}
              onChange={(e) => setProduct1(e.target.value)}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Product 2</label>
            <input
              type="text"
              placeholder="Enter second product url"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
              value={product2}
              onChange={(e) => setProduct2(e.target.value)}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">What do you want to compare?</label>
            <input
              type="text"
              placeholder="Ex: Battery life and performance"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
              value={userQuery}
              onChange={(e) => setUserQuery(e.target.value)}
            />
          </div>
          
          <button
            onClick={handleCompare}
            disabled={!product1 || !product2}
            className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all duration-300 ease-in-out"
          >
            Compare Products
          </button>
        </div>
        </div>
        </div>
        </>
  );
};

export default Compare;